import React from 'react';

import {
  Wifi1Icon,
  Wifi2Icon,
  Wifi3Icon,
  Wifi4Icon,
  WifiOff,
} from '../../../assets';
import { useTheme } from '@mui/material';

interface GetWifiSignalIconProps extends React.SVGProps<SVGSVGElement> {
  rssi: number | null | undefined;
}
/* Connection RSSI strength (-30 is Perfect -90 is bad) */
export const GetWifiSignalIcon = (props: GetWifiSignalIconProps) => {
  const { rssi, ...rest } = props;
  const theme = useTheme();
  const normalColor = theme.palette.success.main;
  const defaultProps = { height: '100%', color: normalColor };
  const combinedProps = { ...defaultProps, ...rest };
  let icon = null;

  const invalidRSSI = rssi === null || rssi === undefined || isNaN(rssi);
  if (invalidRSSI) {
    icon = <WifiOff {...combinedProps} />;
  } else if (rssi >= -69) {
    icon = <Wifi4Icon {...combinedProps} />;
  } else if (rssi >= -94) {
    icon = <Wifi3Icon {...combinedProps} />;
  } else if (rssi >= -104) {
    icon = <Wifi2Icon {...combinedProps} />;
  } else {
    icon = <Wifi1Icon {...combinedProps} />;
  }
  return icon;
};
